export * from './LocalitiesConfigRepository';
